import { v2Request } from './client';

/** @param {{ name: string, mobile: string }} body */
export function pilotAuthRegister(body) {
  return v2Request('/api/auth/register', { method: 'POST', body });
}

/** @param {{ mobile: string }} body */
export function pilotAuthLogin(body) {
  return v2Request('/api/auth/login', { method: 'POST', body });
}

/** @param {{ mobile: string, otp: string }} body */
export function pilotAuthValidateOtp(body) {
  return v2Request('/api/auth/validate-otp', {
    method: 'POST',
    body: { mobile: body.mobile, otp: String(body.otp).trim() },
  });
}
